<template>
  <div
    data-test="graphics-dataListSettings"
  >
    <SidebarSettingsGroup
      title="List Layout"
      collapsible
      :element-type="element.type"
      data-test="graphics-dataListSettings-listLayout"
    >
      <div class="flex margin-bottom-sm">
        <label class="sidebar-form-label">
          <span>
            Direction&nbsp;

            <span
              aria-label="Direction to display your data"
              aria-label-up-right
            >
              <span class="fas fa-info-circle" />
            </span>
          </span>

          <select
            v-model="layout"
            data-test="graphics-dropdown-direction"
            data-entity="graphics-dataListSettings-selectDirection"
          >
            <option value="column">Vertical</option>
            <option value="row">Horizontal</option>
          </select>
        </label>
      </div>

      <div class="flex margin-bottom-sm">
        <label class="sidebar-form-label">
          Spacing

          <input
            v-model.number="gap"
            type="number"
            placeholder="0"
            data-test="graphics-input-spacing"
            data-entity="graphics-dataListSettings-setSpacing"
          >
        </label>
      </div>
    </SidebarSettingsGroup>

    <data-filter :element="element" />

    <SidebarSettingsGroup
      title="Style & Animation"
      collapsible
      :element-type="element.type"
      data-test="graphics-dataListSettings-styleAndAnimation"
    >
      <animation-settings :element="element" />
    </SidebarSettingsGroup>
  </div>
</template>

<script>
import AnimationSettings from './Animation.vue';
import settingsMixins from '../../mixins/settings-mixins';
import DataFilter from './DataFilters.vue';

export default {
  name: 'DataListSettings',
  components: {
    AnimationSettings,
    DataFilter,
  },
  mixins: [settingsMixins],

  props: ['element'],

  computed: {

    layout: {
      get() {
        return this.getPropertyValue('settings.layout');
      },
      set(v) {
        this.updateOneElementValue('settings.layout', v);
      },
    },

    gap: {
      get() {
        return this.getPropertyValue('settings.gap');
      },
      set(v) {
        this.updateOneElementValue('settings.gap', v);
      },
    },

  },

  methods: {
    incrementPage(amount = 1) {
      this.paginationPage = Math.max(1, this.paginationPage + amount);
    },
  },
};
</script>
